import type { TranslateFunction } from '../types/front/common';

export function getTranslatedKey(t: TranslateFunction, key?: string): string {
  return t(`counterType.key.${key}`) === `counterType.key.${key}`
    ? key!
    : t(`counterType.key.${key}`);
}
